import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import {
	CompanyBuildingListResult,
	CompanyBuildingsState,
} from '@localTypes/companyBuildings';

const initialState: CompanyBuildingsState = {};

export const companyBuildingsSlice = createSlice({
	initialState,
	name: 'company_buildings',
	reducers: {
		clearAllCompanyBuildings: () => ({}),
		clearCompanyBuildings: (state, action: PayloadAction<number>) => {
			const companyId = action.payload;
			delete state[companyId];
		},
		setCompanyBuildings: (state, action: PayloadAction<{
			companyId: number;
			result: CompanyBuildingListResult['result'];
		}>) => {
			const {
				companyId,
				result,
			} = action.payload;
			state[companyId] = {
				isError: false,
				isLoading: false,
				result,
			};
		},
		setCompanyBuildingsError: (state, action: PayloadAction<{
			companyId: number;
			isError: boolean;
		}>) => {
			const {
				companyId,
				isError,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
				};
			}
			state[companyId].isError = isError;
		},
		setCompanyBuildingsLoading: (state, action: PayloadAction<{
			companyId: number;
			isLoading: boolean;
		}>) => {
			const {
				companyId,
				isLoading,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
				};
			}
			state[companyId].isLoading = isLoading;
		},
	},
});

export const {
	clearAllCompanyBuildings,
	clearCompanyBuildings,
	setCompanyBuildings,
	setCompanyBuildingsError,
	setCompanyBuildingsLoading,
} = companyBuildingsSlice.actions;

export const companyBuildingsReducer = companyBuildingsSlice.reducer;
